import { animate } from "framer-motion"
import { useEffect, useRef } from "react"

const format = (value: number) => Math.round(value).toLocaleString("ru-RU")

/**
 * Число, которое перетекает к новому значению, а не подменяется: счётчик получателей,
 * число людей в группе. Первое значение встаёт сразу, без отсчёта от нуля. Значение
 * пишется прямо в текст узла, мимо перерисовки React на каждом кадре.
 */
export function AnimatedNumber({ value, className }: { value: number; className?: string }) {
	const ref = useRef<HTMLSpanElement>(null)
	const shown = useRef(value)

	useEffect(() => {
		const node = ref.current
		if (!node || shown.current === value) return
		const controls = animate(shown.current, value, {
			duration: 0.5,
			ease: [0.4, 0, 0.2, 1],
			onUpdate: (current) => {
				shown.current = current
				node.textContent = format(current)
			},
		})
		return () => controls.stop()
	}, [value])

	return (
		<span ref={ref} className={className}>
			{format(shown.current)}
		</span>
	)
}
